// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { OrderService } from '../../../../../services/order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { UserService } from '../../../../../services/user.service';
import { PAY_STATUS, UserType } from '../../../../../model/Const';
import { en_US } from 'ng-zorro-antd/i18n';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { TwNoticeService } from '../../../../../services/tw-notice.service';
import { Observable, Observer } from 'rxjs';
import { SyllabusService } from '../../../../../services/syllabus.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { TagsService } from '../../../../../services/tags.service';
import { trigger, state, style, animate, transition, group } from '@angular/animations';
import {ResourcePushTemplateAgeLevel, ResourcePushTemplateAgeLevels} from '../../../../../model/ResourcePushTemplate';
import { CheckPointsService } from '../../../../../services/checkPoints.service';
import { TreeNode } from '../../../../common/custom-tree/custom-tree.component';


@Component({
    selector: 'app-admin-book-category-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    animations: [
        trigger('rotateIcon', [
            state('collapsed', style({
                transform: 'rotate(0deg)'
            })),
            state('expanded', style({
                transform: 'rotate(180deg)'
            })),
            transition('collapsed <=> expanded', [
                animate('200ms ease-out')
            ])
        ]),
        trigger('expandCollapse', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate('200ms ease-out', style({ height: '*', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '*', opacity: 1 }),
                animate('200ms ease-in', style({ height: 0, opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class AdminBookCategoryIndexComponent implements OnInit, AfterViewInit {

  isLoading = false;
  isAddCategoryVisible = false;
  isDeleteVisible = false;
  newThemeCategoryVisible = false;
  tabIndex = 0;
  userInfo: any = {};
  // expandedNodes = new Set<number>();

  tabs: any = [];
  tabsReady = false;
  pageReady = false;
  tags: any = [];
  rootCate = {id: 0, name: ''};
  checkPoints: any = [];
  isDraggingCheckPoint = false;
  // childCate = {id: 0, name: ''};
  // cateForm!: UntypedFormGroup;
  // themeForm!: UntypedFormGroup;

  //
  itemForm!: UntypedFormGroup;
  editItem = {id: 0, pid: 0, name: ''};
  cateItem: any = {id: 0, pid: 0, name: '', children: []};
  formDialogVisible = false;
  cateTabIndex = 0;

  // 路径管理相关属性
  pathForm!: UntypedFormGroup;
  pathEditItem = {id: 0, pid: 0, name: '', syllabus_id: 0};
  pathDialogVisible = false;
  isPathEdit = false;
  pathTitle = '';
  pathFormFields: string[] = [];

  // themeCategoryForm!: UntypedFormGroup;
  tableScroll = 500;
  isEdit = false;
  addPid = 0;
  title = '';
  formFields: string[] = [];
  // bisType = 'cartoon';
  resourceType = '';
  resourceTitle = '';

  selectedCateIndex = -1;

  @ViewChild('basicTable', {static: true}) basicTable: ElementRef | undefined;

  // 当前展开大纲的模板列表
  protected ResourcePushTemplateAgeLevels: Array<{ template_id: number; template_name: string; syllabus_id: number; template_desc?: string }> = [];

  // 当前展开的大纲ID
  protected currentExpandedSyllabusId: number = 0;

  // 模板管理相关属性
  templateForm!: UntypedFormGroup;
  templateDialogVisible = false;
  isTemplateEdit = false;
  templateEditItem: any = { template_id: 0, template_name: '', template_desc: '', syllabus_id: 0 };


  constructor(private orderService: OrderService,
              private nzContextMenuService: NzContextMenuService,
              private modalService: NzModalService,
              private userService: UserService,
              private syllabusService: SyllabusService,
              private checkPointsService: CheckPointsService,
              private tagsService: TagsService,
              private twNoticeService: TwNoticeService,
              private activatedRoute: ActivatedRoute ,
              private fb: UntypedFormBuilder,
              private router: Router ,
              private elRef: ElementRef,
              private nzMessageService: NzMessageService) {
    this.userInfo = this.userService.getUserInfo();
    // console.log('info', this.userInfo);
    // this.checkSubsidyModelOpen.subscribe((evt) => {
    //   console.log('modal open');
    // });

    // @ts-ignore
    // let version = this.router.browserUrlTree.root.children.primary?.segments[1]?.path;
    // @ts-ignore
    // this.bisType = this.router.browserUrlTree.root.children.primary?.segments[3]?.path;
    this.resourceType = this.router.url.split('?')[0].split('/').filter(Boolean)[3] ?? '';
    console.log('[category] index', this.resourceType);
    if (this.resourceType === 'book') {
      this.resourceTitle = '教材';
    } else if (this.resourceType === 'cartoon') {
      this.resourceTitle = '绘本';
    }

    this.itemForm = this.fb.group({
      id: [null ],
      pid: [0],
      syllabus_id: [0],
      // bis_type: [this.bisType],
      name: ['', [ Validators.required ], [ this.themeNameAsyncValidator ] ],
      // description: [''],
      cover: [''],
    });

    // 初始化路径表单
    this.pathForm = this.fb.group({
      id: [null],
      pid: [0],
      syllabus_id: [0],
      name: ['', [Validators.required], [this.pathNameAsyncValidator]],
      cover: [''],
    });

    // 初始化模板表单
    this.templateForm = this.fb.group({
      template_name: ['', [Validators.required], [this.templateNameAsyncValidator]],
      template_desc: ['']
    });

  }
  afterModalClose() {

  }




  handleDeleteCancel() {
    this.isDeleteVisible = false;
  }
  handleViewDelete(row: any) {
    this.isDeleteVisible = true;
  }

  ngAfterViewInit() {
    // this.tableScroll = {y: window.innerHeight - 48 - 56 - 72 - 54 - 64 - 136}
    // window.tableScroll = this.tableScroll;
    // window.basicTable = this.basicTable
    this.tableScroll =  window.innerHeight  - 56 - 72 - 54 - 64 ;
    console.log('tableScroll', this.tableScroll);
  }
  ngOnInit() {
    this.cateTabIndex = 0;
    this.tabIndex = 0;
    this.tabsReady = false;
    this.loadCateData();
  }





  openItemDialog(item: any, title: string, fields= [], $event?: any) {
    $event?.stopPropagation();
    if (this.isDraggingCheckPoint) {
      return;
    }
    console.log('openItemDialog', item);
    if (!item) {
      return;
    }
    this.editItem = item;
    this.itemForm.reset();
    this.title = title;
    this.formDialogVisible = true;
    this.formFields = fields;
    if (item.id && item.id !== '' && +item.id > 0 && !isNaN(+item.id)) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
    if (this.itemForm && this.itemForm.controls) {
      for (const name in this.itemForm.controls) {
        // @ts-ignore
        this.itemForm.controls[name].setValue(item[name] || '');
      }
    }
  }
  closeItemDialog() {
    console.log('closeItemDialog');
    this.formDialogVisible = false;
    this.itemForm.reset();
    this.title = '';
    // this.editItem = {id: 0, pid: 0, name: ''};
    this.isEdit = false;
  }

  // 路径管理相关方法
  openPathDialog(item: any, title: string, fields: string[] = [], $event?: any) {
    console.log('openPathDialog')
    $event?.stopPropagation();
    if (!item) {
      return;
    }

    this.pathEditItem = item;
    this.pathForm.reset();
    this.pathTitle = title;
    this.pathDialogVisible = true;
    this.pathFormFields = fields;
    if (item.id && item.id !== '' && +item.id > 0 && !isNaN(+item.id)) {
      this.isPathEdit = true;
    } else {
      this.isPathEdit = false;
    }
    if (this.pathForm && this.pathForm.controls) {
      for (const name in this.pathForm.controls) {
        // @ts-ignore
        this.pathForm.controls[name].setValue(item[name] || '');
      }
    }
  }

  closePathDialog() {
    console.log('closePathDialog');
    this.pathDialogVisible = false;
    this.pathForm.reset();
    this.pathTitle = '';
    this.isPathEdit = false;
  }

  pathCoverUploaded($event: any) {
    console.log('pathCoverUploaded', $event);
    if (this.pathForm && this.pathForm.controls && this.pathForm.controls['cover']) {
      this.pathForm.controls['cover'].setValue($event.url || '');
    }
  }

  submitPathForm = ($event: any, value: any) => {
    $event.preventDefault();
    if (this.isLoading) {
      return;
    }
    if (!value.cover) {
      delete value.cover;
    }

    value.seq = 0;
    value.pid = this.pathEditItem.pid;
    value.syllabus_id = this.pathEditItem.syllabus_id;

    if (!value.pid) {
      value.pid = 0;
      value.root = 1;
      value.depth = 1;
    } else {
      value.root = 0;
      value.depth = 2;
    }

    console.log('submitPathForm', value);
    this.isLoading = true;
    this.syllabusService.save(this.resourceType, value).then((res: any) => {
      this.twNoticeService.success({
        nzContent: `${value.id ? '編輯' : '新增'}成功`,
      });
      this.closePathDialog();
      this.isLoading = false;
      this.loadCateData();
    }).catch((err: any) => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System error');
    });
  }

  removePathItem(item: any) {
    const form = this.pathForm;
    console.log('removePathItem', form.controls);
    if (form && form.controls && form.controls['name'] && form.controls['id']) {
      const modal = this.twNoticeService.confirm({
        nzTitle: `是否刪除「${form.controls['name'].value}」${this.pathTitle}？`,
        nzContent: '確定刪除後將無法復原，是否仍執行此動作？',
        nzOnOk: (e: any) => {
          this.syllabusService.deleteItem(this.resourceType, {id: form.controls['id'].value}).then((res: any) => {
            this.pathDialogVisible = false;
            this.twNoticeService.success({
              nzContent: `刪除「${form.controls['name'].value}」${this.pathTitle}`,
            });
            modal.close();
            this.loadCateData();
          }).catch((err: { message: any; }) => {
            this.nzMessageService.error(err.message || 'System error');
          });
        }
      });
    }
  }


  themeNameAsyncValidator = (control: UntypedFormControl) => new Observable((observer: Observer<ValidationErrors | null>) => {
    console.log('control', control.dirty,  control.value);
    // @ts-ignore
    // if (this.cate.name === control.value) {
    if (!control.dirty) {
      // @ts-ignore
      observer.next(null);
      observer.complete();
      return;
    }

    const data = {
      id: (this.itemForm && this.itemForm.controls && this.itemForm.controls['id']) ? this.itemForm.controls['id'].value || 0 : 0,
      pid: (this.itemForm && this.itemForm.controls && this.itemForm.controls['pid']) ? this.itemForm.controls['pid'].value || 0 : 0,
      school_id: this.userInfo.school_id || 0,
      // bis_type: this.bisType,
      name: control.value
    };
    if (this.itemForm && this.itemForm.controls && this.itemForm.controls['syllabus_id'] && this.itemForm.controls['syllabus_id'].value) {
      // @ts-ignore
      data['syllabus_id'] = this.itemForm.controls['syllabus_id'].value;
    }

    let svc = this.syllabusService;
    if (this.tabIndex === 1) {
      // @ts-ignore
      svc = this.tagsService;
    }
    if (this.tabIndex === 2) {
      // @ts-ignore
      data.check_point = data.name;
      delete data.name;
      // @ts-ignore
      svc = this.checkPointsService;
    }

    svc.checkNameExist(this.resourceType, data).then(resp => {
      console.log(99, resp);
      if (resp.id) {
        observer.next({ error: true, duplicated: true });
      } else {
        // @ts-ignore
        observer.next(null);
      }
      observer.complete();
    });
  })

  // 路径名称异步验证器
  pathNameAsyncValidator = (control: UntypedFormControl) => new Observable((observer: Observer<ValidationErrors | null>) => {
    console.log('pathNameAsyncValidator', control.dirty, control.value);
    if (!control.dirty) {
      observer.next(null);
      observer.complete();
      return;
    }

    const data = {
      id: (this.pathForm && this.pathForm.controls && this.pathForm.controls['id']) ? this.pathForm.controls['id'].value || 0 : 0,
      pid: (this.pathForm && this.pathForm.controls && this.pathForm.controls['pid']) ? this.pathForm.controls['pid'].value || 0 : 0,
      syllabus_id: (this.pathForm && this.pathForm.controls && this.pathForm.controls['syllabus_id']) ? this.pathForm.controls['syllabus_id'].value || 0 : 0,
      name: control.value
    };

    this.syllabusService.checkNameExist(this.resourceType, data).then(resp => {
      console.log('pathNameAsyncValidator response', resp);
      if (resp.id) {
        observer.next({ error: true, duplicated: true });
      } else {
        observer.next(null);
      }
      observer.complete();
    });
  })

  // 模板名称异步验证器
  templateNameAsyncValidator = (control: UntypedFormControl) => new Observable((observer: Observer<ValidationErrors | null>) => {
    if (!control.dirty) {
      observer.next(null);
      observer.complete();
      return;
    }

    // 检查是否与当前大纲下现有模板名称重复（排除当前编辑的模板）
    const existingTemplate = this.ResourcePushTemplateAgeLevels.find(t =>
      t.template_name === control.value &&
      t.template_id !== this.templateEditItem.template_id
    );

    if (existingTemplate) {
      observer.next({ duplicated: true });
    } else {
      observer.next(null);
    }
    observer.complete();
  });

  async loadCateData() {
    this.isLoading = true;
    this.tabsReady = false;
    const url = `/syllabus/${this.resourceType}/category`;
    try {
      const data = await this.syllabusService.get(url);
      this.tabs = data.syllabus || [];
      setTimeout(() => {
        this.applyCateTabSelection();
        this.pageReady = true;
      });
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }

  private syncCateTabSelection(): void {
    this.tabsReady = false;
    setTimeout(() => {
      this.applyCateTabSelection();
    });
  }

  private applyCateTabSelection(): void {
    if (!this.tabs.length) {
      this.cateTabIndex = 0;
      this.cateItem = { id: 0, pid: 0, name: '', children: [] };
      this.tabsReady = true;
      return;
    }
    const nextIndex = Math.min(this.cateTabIndex, this.tabs.length - 1);
    this.cateTabIndex = nextIndex;
    this.cateItem = this.tabs[nextIndex];
    if (this.cateItem?.children) {
      this.ensureTreeDataKeys(this.cateItem.children);
    }
    this.tabsReady = true;
  }

  // 确保树形数据有正确的key属性
  private ensureTreeDataKeys(nodes: any[]) {
    if (!nodes || !Array.isArray(nodes)) {
      return;
    }

    nodes.forEach((node, index) => {
      // 如果没有key，使用id作为key
      if (!node.key) {
        node.key = node.id || `node_${index}`;
      }

      // 递归处理子节点
      if (node.children && Array.isArray(node.children)) {
        this.ensureTreeDataKeys(node.children);
      }
    });
  }

  // 处理树形数据，添加key属性

  async loadTagsData () {
    this.isLoading = true;
    // const url = `/tags/${this.resourceType}/tree?bis_type=${this.bisType}`;
    const url = `/syllabus/${this.resourceType}/category`;
    this.tagsService.get(url).then(data => {
      this.isLoading = false;
      const _themes: any = {};
      data.themes.forEach((item: any) => {
        if (!_themes[item.syllabus_id]) {
          _themes[item.syllabus_id] = [];
        }
        _themes[item.syllabus_id].push(item);
      });
      this.tabs = data.syllabus || [];
      this.tags = _themes;
      this.syncCateTabSelection();
    }).catch((err: any) => {
      console.log(err);
      this.isLoading = false;
    });
  }

  // 获取考察点
  async loadCheckPointsData () {
    this.isLoading = true;
    // const url = `/tags/${this.resourceType}/tree?bis_type=${this.bisType}`;
    const url = `/syllabus/${this.resourceType}/checkPoints`;
    this.syllabusService.get(url).then(data => {
      this.isLoading = false;
      const _checkPoints: any = {};
      data.checkPoints.forEach((item: any) => {
        if (!_checkPoints[item.syllabus_id]) {
          _checkPoints[item.syllabus_id] = [];
        }
        _checkPoints[item.syllabus_id].push(item);
      });
      console.log('checkPoints', _checkPoints)
      this.checkPoints = _checkPoints;
    }).catch((err: any) => {
      console.log(err);
      this.isLoading = false;
    });
  }

  tabIndexChange(index: number) {
    console.log('tabIndexChange', index);
    this.tabIndex = index;
    if (index === 1) {
      this.loadTagsData();
    } else if (index === 2) {
      this.loadCheckPointsData();
    }
  }
  cateIndexChange(index: number) {
    if (this.cateTabIndex === index) {
      return;
    }
    console.log('cateIndexChange', index);
    this.cateTabIndex = index;
    this.selectedCateIndex = -1;
    this.cateItem = this.tabs[index];
    if (this.cateItem?.children) {
      this.ensureTreeDataKeys(this.cateItem.children);
    }
  }
  newThemeCategory(data: any) {
    console.log('newThemeCategory', data);
    this.newThemeCategoryVisible = true;
    this.title = '主题分类';
  }
  submitItemForm = ($event: any, value: any) => {
    $event.preventDefault();
    if (this.isLoading) {
      return;
    }
    if (!value.cover) {
      delete value.cover;
    }

    value.seq = 0;
    if (this.resourceType === 'cartoon') {

    } else {

    }
    // value.bis_type = this.bisType;
    let svc = this.syllabusService;
    let loadFn = this.loadCateData.bind(this);
    if (this.tabIndex === 1) {
      // @ts-ignore
      svc = this.tagsService;
      loadFn = this.loadTagsData.bind(this);
      value.pid = this.editItem.pid;
    } else if (this.tabIndex === 2) {
      // @ts-ignore
      svc = this.checkPointsService;
      loadFn = this.loadCheckPointsData.bind(this);
      value.pid = 0
      value.check_point = value.name
    } else {
      value.pid = this.editItem.pid;
    }

    if (!value.pid) {
      value.pid = 0;
      value.root = 1;
      value.depth = 1;
    } else {
      value.root = 0;
      value.depth = 2;
    }


    console.log('submitItemForm', value);
    this.isLoading = true;
    svc.save(this.resourceType, value).then((res: any) => {
      this.twNoticeService.success({
        nzContent: `${value.id ? '編輯' : '新增'}成功`,
      });
      this.closeItemDialog();
      this.isLoading = false;
      loadFn();
    }).catch((err: any) => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System error');
    });
  }
  removeItem(item: any) {
    // this.isAddCategoryVisible = false;

    let svc = this.syllabusService;
    // let form = this.cateForm;
    const form = this.itemForm;
    let loadFn = this.loadCateData.bind(this);
    if (this.tabIndex === 1) {
      // @ts-ignore
      svc = this.tagsService;
      // form = this.themeForm;
      loadFn = this.loadTagsData.bind(this);
    } else if (this.tabIndex === 2) {
      // @ts-ignore
      svc = this.checkPointsService;
      loadFn = this.loadCheckPointsData.bind(this);
    }
    console.log('removeItem', form.controls);
    if (form && form.controls && form.controls['name'] && form.controls['id']) {
      const modal = this.twNoticeService.confirm({
        nzTitle: `是否刪除「${form.controls['name'].value}」${this.title}？`,
        nzContent: '確定刪除後將無法復原，是否仍執行此動作？',
        nzOnOk: (e: any) => {
          svc.deleteItem( this.resourceType, {id: form.controls['id'].value}).then((res: any) => {
            this.formDialogVisible = false;
          this.twNoticeService.success({
            nzContent: `刪除「${form.controls['name'].value}」${this.title}`,
          });
            modal.close();
            loadFn();
          }).catch((err: { message: any; }) => {
            this.nzMessageService.error(err.message || 'System error');
          });
        }
      });
    }
  }



  submitThemeCategoryForm = ($event: any, value: any) => {
    $event.preventDefault();
    if (this.isLoading) {
      return;
    }
    if (!value.cover) {
      delete value.cover;
    }
    value.syllabus_id = this.rootCate.id;

    value.syllabus_id = this.cateItem.id;
    // value.bis_type = this.bisType;
    // let svc = this.syllabusService;
    // const loadFn = this.loadCateData.bind(this);
    // if (this.tabIndex == 1) {
    //   // @ts-ignore
    //   svc = this.themeService;
    const  loadFn = this.loadTagsData.bind(this);
    // } else {
    //
    // }
    value.pid = this.addPid;

    console.log('submitThemeCategoryForm', value);
    this.isLoading = true;
    this.tagsService.save(this.resourceType, value).then((res: any) => {
      this.twNoticeService.success({
        nzContent: `${value.id ? '編輯' : '新增'}成功`,
      });
      this.newThemeCategoryVisible = false;
      this.isEdit = false;
      // this.themeCategoryForm.reset();
      this.isLoading = false;
      loadFn();
    }).catch((err: any) => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System error');
    });
  }

  coverUploaded($event: any) {
    console.log('coverUploaded', $event);
    // this.isAddCategoryVisible = true;
    // let form = this.cateForm;
    // if (this.tabIndex == 1) {
    //   form = this.themeForm;
    // }
    // form.controls['cover'].setValue($event.url || '');
    if (this.itemForm && this.itemForm.controls && this.itemForm.controls['cover']) {
      this.itemForm.controls['cover'].setValue($event.url || '');
    }
  }
  sortCate($event: any) {
    if ($event.previousIndex === $event.currentIndex) {
      return;
    }
    if (!this.tabs || !Array.isArray(this.tabs)) {
      return;
    }
    moveItemInArray(this.tabs, $event.previousIndex, $event.currentIndex);
    const data = this.tabs.map((item: any, index: number) => {
      return [item.id, index];
    });
    console.log('drop', data);
    this.isLoading = true;
    // return this.syllabusService.seq(this.bisType, data).then((res: any) => {
    return this.syllabusService.seq(this.resourceType, data).then((res: any) => {
      this.isLoading = false;
      this.cateTabIndex = 0;
      this.loadCateData();
      // this.themes.length = 0;
    }).catch((err: any) => {
      console.log(err);
      this.nzMessageService.error(err.message || 'System Error');
      this.isLoading = false;
    });
  }
  sortSubCate($event: any) {
    if ($event.previousIndex === $event.currentIndex) {
      return;
    }

    if (!this.cateItem || !this.cateItem.children) {
      return;
    }

    const {children} = this.cateItem;
    const previousChildren = [...children]; // 保存原始顺序用于回滚

    // 更新UI
    moveItemInArray(children, $event.previousIndex, $event.currentIndex);

    // 准备API数据
    const data = children.map((item: any, index: number) => {
      return [item.id, index];
    });

    this.isLoading = true;

    return this.syllabusService.seq(this.resourceType, data).then((res: any) => {
      this.isLoading = false;
      this.loadCateData();
      // this.tags.length = 0;
    }).catch((err: any) => {
      console.log(err);

      this.cateItem.children = [...previousChildren];
      this.nzMessageService.error(err.message || 'System Error');
      this.isLoading = false;
    });
  }
  onCheckPointDragEnded() {
    setTimeout(() => this.isDraggingCheckPoint = false);
  }

  sortCheckPoints(event: CdkDragDrop<any[]>, panelId: number) {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    const items = this.checkPoints[panelId];
    if (!items || !Array.isArray(items)) {
      return;
    }

    const previousItems = [...items];
    moveItemInArray(items, event.previousIndex, event.currentIndex);

    const payload = {
      items: items.map((item: any, index: number) => ({
        id: item.id,
        seq: index
      }))
    };

    this.isLoading = true;
    this.checkPointsService.updateCheckPointSeq(this.resourceType, payload).then((res: any) => {
      this.isLoading = false;
      this.nzMessageService.success('排序更新成功');
    }).catch((err: any) => {
      this.checkPoints[panelId] = previousItems;
      this.isLoading = false;
      this.nzMessageService.error(err.message || '排序更新失败');
    });
  }

  closeThemeCategoryDialog() {
    this.newThemeCategoryVisible = false;
  }

  toggleCate(index: number) {
    const newIndex = this.selectedCateIndex === index ? -1 : index;
    this.selectedCateIndex = newIndex;

    if (newIndex !== -1) {
      // 展开：加载该大纲的模板数据
      if (this.cateItem?.children?.[index]?.id) {
        const syllabusId = this.cateItem.children[index].id;
        this.loadTemplateData(syllabusId);
      }
    } else {
      // 收起：清空模板数据
      this.ResourcePushTemplateAgeLevels = [];
      this.currentExpandedSyllabusId = 0;
    }
  }

  // 加载指定大纲的模板数据
  loadTemplateData(syllabusId: number) {
    if (!syllabusId) {
      return;
    }

    this.currentExpandedSyllabusId = syllabusId;
    this.isLoading = true;

    this.syllabusService.getTemplateList(syllabusId).then((res: any) => {
      this.ResourcePushTemplateAgeLevels = res || [];
      this.isLoading = false;
    }).catch((err: any) => {
      console.log(err);
      this.nzMessageService.error(err.message || '加载模板数据失败');
      // 如果API调用失败，使用默认模板数据作为后备
      this.ResourcePushTemplateAgeLevels = [
        { template_id: 1, template_name: '三周岁起点', syllabus_id: syllabusId },
        { template_id: 2, template_name: '四周岁起点', syllabus_id: syllabusId },
        { template_id: 3, template_name: '五周岁起点', syllabus_id: syllabusId },
        { template_id: 4, template_name: '一二年级起点', syllabus_id: syllabusId },
        { template_id: 5, template_name: '三四年级起点', syllabus_id: syllabusId }
      ];
      this.isLoading = false;
    });
  }

  // 打开模板编辑对话框
  openTemplateDialog(template?: any, syllabusId?: number) {
    const currentSyllabusId = syllabusId || this.cateItem?.id || 0;
    this.templateEditItem = template ? { ...template } : { template_id: 0, template_name: '', template_desc: '', syllabus_id: currentSyllabusId };
    this.isTemplateEdit = !!template;
    this.templateForm.reset();

    if (template) {
      // 编辑模式：填充模板名称和介绍
      this.templateForm.patchValue({
        template_name: template.template_name,
        template_desc: template.template_desc || ''
      });
    }
    // 新增模式：表单为空，等待用户输入

    this.templateDialogVisible = true;
  }

  // 提交模板表单
  submitTemplateForm() {
    if (this.templateForm.invalid) {
      return;
    }

    const formData = this.templateForm.value;
    const syllabusId = this.templateEditItem.syllabus_id || 0;

    // 构建提交数据
    const submitData: any = {
      syllabus_id: syllabusId,
      template_name: formData.template_name,
      template_desc: formData.template_desc || ''
    };

    if (this.isTemplateEdit) {
      // 编辑模式：需要template_id
      submitData.template_id = this.templateEditItem.template_id;
    } else {
      // 新增模式：计算新的template_id
      if (this.ResourcePushTemplateAgeLevels.length === 0) {
        submitData.template_id = 6; // 默认值
      } else {
        const maxTemplateId = Math.max(...this.ResourcePushTemplateAgeLevels.map(t => t.template_id));
        submitData.template_id = maxTemplateId + 1;
      }
    }

    this.isLoading = true;

    this.syllabusService.saveTemplate(submitData).then((res: any) => {
      this.isLoading = false;
      this.templateDialogVisible = false;
      // 重新加载当前展开大纲的模板数据
      if (this.currentExpandedSyllabusId) {
        this.loadTemplateData(this.currentExpandedSyllabusId);
      }
      this.nzMessageService.success(this.isTemplateEdit ? '模板更新成功' : '模板创建成功');
    }).catch((err: any) => {
      console.log(err);
      this.nzMessageService.error(err.message || '保存模板失败');
      this.isLoading = false;
    });
  }

  // 删除模板
  deleteTemplate(template: any) {
    this.modalService.confirm({
      nzTitle: '确认删除',
      nzContent: `确定要删除模板"${template.template_name}"吗？`,
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        this.isLoading = true;
        this.syllabusService.deleteTemplate(template.syllabus_id, template.template_id).then((res: any) => {
                  this.isLoading = false;
        this.templateDialogVisible = false; // 关闭弹窗
        // 重新加载当前展开大纲的模板数据
        if (this.currentExpandedSyllabusId) {
          this.loadTemplateData(this.currentExpandedSyllabusId);
        }
        this.nzMessageService.success('模板删除成功');
        }).catch((err: any) => {
          console.log(err);
          this.nzMessageService.error(err.message || '删除模板失败');
          this.isLoading = false;
        });
      }
    });
  }

  // 关闭模板对话框
  closeTemplateDialog() {
    this.templateDialogVisible = false;
  }

  async handleEditTemplate(categorySubId: number, ageLevel: ResourcePushTemplateAgeLevel, categoryId: number) {
    await this.router.navigate([`/admin/v3/resource/${this.resourceType}/category/template`], {
      queryParams: {
        categorySubId,
        ageLevel,
        categoryId,
      },
    });
  }

  // 处理路径节点拖拽排序
  onPathNodeDrop(dropEvent: {event: any, level: number, parentId?: number}) {
    console.log('路径节点拖拽事件:', dropEvent);

    if (dropEvent.event.previousIndex === dropEvent.event.currentIndex) {
      return;
    }

    // 准备API数据
    const nodes = dropEvent.event.container.data;
    if (!nodes || !Array.isArray(nodes)) {
      return;
    }
    const data = nodes.map((item: any, index: number) => {
      return [item.id, index];
    });

    console.log('排序数据:', data);

    this.isLoading = true;
    this.syllabusService.seq(this.resourceType, data).then((res: any) => {
      this.isLoading = false;
      this.loadCateData();
      this.twNoticeService.success({
        nzContent: '排序更新成功',
      });
    }).catch((err: any) => {
      console.log(err);
      this.nzMessageService.error(err.message || 'System Error');
      this.isLoading = false;
      // 重新加载数据以恢复原始顺序
      this.loadCateData();
    });
  }

  protected readonly UserType = UserType;
}
